'use strict';

import Api from "./Api";

export default class Statistics extends Api {

    static getBalance() {
        const url = this.url + 'statistics/get-balance';

        return this.getAxios().get(url);
    }

    static getCash() {
        const url = this.url + 'statistics/get-cash';

        return this.getAxios().get(url);
    }

    static getCard() {
        const url = this.url + 'statistics/get-card';

        return this.getAxios().get(url);
    }

    static getLess() {
        const url = this.url + 'statistics/get-less';

        return this.getAxios().get(url);
    }

    static getTotalToday() {
        const url = this.url + 'statistics/get-total-today';

        return this.getAxios().get(url);
    }

    static getTotalMonth() {
        const url = this.url + 'statistics/get-total-month';

        return this.getAxios().get(url);
    }

}